import Box from "@/ui/atoms/Box";
import { Icon, IconBox, Tooltip } from "@proda-ai/ui-kit";
import Typography from "@/ui/atoms/Typography";
import React from "react";
import type { TLabelsetInfo } from "@/apis/odin/apiODIN";
import LabelsetSourceInfoCard from "@/ui/molecules/LabelsetSourceInfoCard";
import LabelsetInfoDropdown from "@/ui/molecules/LabelsetInfoDropdown";

export type labelsetExtractionInfo = {
    labelsetExtractionInfo: Array<TLabelsetInfo>;
    labelsetSourceId: number | null;
    onLabelsetSourceChange: (id: number | null) => void;
};
const ExtractionLabelset: React.FC<labelsetExtractionInfo> = ({
    labelsetExtractionInfo,
    labelsetSourceId,
    onLabelsetSourceChange: onLabelsetSourceChange,
}) => {
    const selectedFileDetails =
        labelsetExtractionInfo.find(
            labelset => labelset.extractionId === labelsetSourceId,
        ) ?? null;

    return (
        <>
            <Box>
                <Typography variant="h3">Account labels</Typography>
                <Box sx={{ paddingTop: "8px" }}>
                    <Typography variant="body2">
                        Account labels are mapped using:
                    </Typography>

                    <Box sx={{ display: "flex", paddingTop: "8px" }}>
                        <Box
                            sx={{
                                width: "4px",
                                height: "24px",
                                flex: "none",
                                order: 1,
                                backgroundColor: "var(--proda-navy-blue)",
                            }}
                        />
                        <Box
                            sx={{
                                flex: "none",
                                height: "24px",
                                boxShadow:
                                    "1px 2px 6px 0px rgba(6, 10, 22, 0.25)",
                                border: "1px solid var(--proda-white-150)",
                                order: 2,
                            }}
                        >
                            <Typography
                                variant="body3"
                                sx={{ fontWeight: 500, padding: "8px" }}
                            >
                                Machine Learning Predictions
                            </Typography>
                        </Box>
                        <Box sx={{ order: 3, paddingLeft: "8px" }}>or</Box>
                    </Box>

                    <Box sx={{ display: "flex", paddingTop: "8px" }}>
                        <Box
                            sx={{
                                width: "4px",
                                height: "24px",
                                flex: "none",
                                order: 1,
                                backgroundColor: "var(--proda-teal)",
                            }}
                        />
                        <Box
                            sx={{
                                flex: "none",
                                height: "24px",
                                boxShadow:
                                    "1px 2px 6px 0px rgba(6, 10, 22, 0.25)",
                                border: "1px solid var(--proda-white-150)",
                                order: 2,
                                paddingRight: "8px",
                            }}
                        >
                            <Typography
                                variant="body3"
                                sx={{ fontWeight: 500, padding: "8px" }}
                            >
                                Previously Uploaded Document(s)
                            </Typography>

                            <Tooltip content="Account labels are mapped using previously uploaded documents. Documents in the dropdown below also show the amount of other files using the same mapping and a percentage of how closely they match.">
                                <IconBox>
                                    <Icon icon="circle-info"></Icon>
                                </IconBox>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ paddingTop: 2 }}>
                    Select below how to best map this document:
                </Box>
                <LabelsetInfoDropdown
                    labelsetExtractionInfo={labelsetExtractionInfo}
                    labelsetSourceId={labelsetSourceId}
                    onLabelsetSourceChange={onLabelsetSourceChange}
                />
            </Box>

            {selectedFileDetails && (
                <LabelsetSourceInfoCard
                    selectedFileDetails={selectedFileDetails}
                />
            )}
        </>
    );
};

export default ExtractionLabelset;
